import { NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingBag, Users, FileText, LogOut, Tag, Gem, Ruler } from "lucide-react";

export default function AdminLayout() {
  const token = localStorage.getItem("duo_admin_token");
  const navigate = useNavigate();
  if (!token) return <Navigate to="/admin/login" />;

  const logout = () => {
    localStorage.removeItem("duo_admin_token");
    localStorage.removeItem("duo_admin_user");
    navigate("/admin/login");
  };

  const links = [
    { to: "/admin", label: "Painel", icon: LayoutDashboard, end: true },
    { to: "/admin/produtos", label: "Produtos", icon: Package },
    { to: "/admin/categorias", label: "Categorias", icon: Tag },
    { to: "/admin/materiais", label: "Materiais", icon: Gem },
    { to: "/admin/tamanhos", label: "Tamanhos", icon: Ruler },
    { to: "/admin/pedidos", label: "Pedidos", icon: ShoppingBag },
    { to: "/admin/clientes", label: "Clientes", icon: Users },
    { to: "/admin/conteudo", label: "Conteúdo", icon: FileText },
  ];

  return (
    <div className="min-h-screen bg-[#F8F5EF] flex" data-testid="admin-layout">
      <aside className="w-64 bg-[#49392F] text-[#F8F5EF] p-6 hidden md:flex md:flex-col">
        <div className="font-display text-2xl mb-1">Duo <span className="italic text-[#C2A064]">Áurea</span></div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#F8F5EF]/60 mb-10">Administração</div>
        <nav className="space-y-1 flex-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-[12px] tracking-[0.2em] uppercase transition-colors ${isActive ? "bg-[#F8F5EF]/10 text-[#C2A064]" : "text-[#F8F5EF]/80 hover:text-[#C2A064]"}`
              }
              data-testid={`admin-nav-${l.label.toLowerCase()}`}
            >
              <l.icon size={16} /> {l.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={logout} className="mt-10 inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-[#F8F5EF]/70 hover:text-[#C2A064]" data-testid="admin-logout">
          <LogOut size={14} /> Sair
        </button>
      </aside>

      <div className="flex-1">
        <header className="md:hidden bg-[#49392F] text-[#F8F5EF] px-6 py-4 flex items-center justify-between">
          <div className="font-display text-xl">Duo <span className="italic text-[#C2A064]">Áurea</span> Admin</div>
          <button onClick={logout}><LogOut size={16} /></button>
        </header>
        <nav className="md:hidden overflow-x-auto no-scrollbar flex gap-2 bg-[#49392F]/95 px-4 pb-3">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `flex-shrink-0 px-3 py-2 text-[10px] tracking-[0.2em] uppercase ${isActive ? "text-[#C2A064]" : "text-[#F8F5EF]/80"}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-6 md:p-10 max-w-[1400px]">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
